export const DYNAMIC_ATTRIBUTE_INITIAL_FORM = [
  {
    trait_type: "",
    placeholder_trait_type: "Trait Name",
    placeholder_value: "Trait Value",
    id: 0,
    value: "",
  },
];
